import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { CommsService } from '../../services/comms/comms.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { HelpService } from '../../services/help/help.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { NoteService } from '../../services/note/note.service';
import { TabService } from '../../services/tab/tab.service';

@Component({
	selector: 'pcm-page-invoices',
	templateUrl: './page-invoices.component.html',
	styleUrls: ['./page-invoices.component.scss']
})
export class PageInvoicesComponent implements OnInit, OnDestroy {

	@ViewChild('modalForm') modalForm;
	title = 'Invoice Reconciliations';
	dataObj = this.invoiceService.dataObj;
	scDataObj = this.invoiceService.scDataObj;
	activeModal = '';
	pending = '';
	selectionType = 'checkbox';
	modalVisible = false;
	actions = [];
	exportAction = [];
	archivedActions = [];
	pendingActions = [];
	showExportModal = false;
	columnsConfig = [];

	defaultSort = [
		{
			prop: this.configService.invoiceChaincodeProp + '.' + this.configService.invoiceDateProp,
			dir: 'desc'
		}
	];

	jrSteps = [];
	jrStepIDs = [];

	initTab = '';

	userSettingsListener;

	partialSuccessTitle = 'Invoices Move to Inactive Error(s)';
	errorMsg = 'Some of the selected invoices failed moving to inactive.  See the table below for details.';
	successMsg = 'The following invoices were moved to inactive tab successfully.';

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private commsService: CommsService,
		public configService: ConfigService,
		private purchaseOrderService: PurchaseOrderService,
		private contractorService: ContractorService,
		private dataService: DataService,
		private displayService: DisplayService,
		public helpService: HelpService,
		public invoiceService: InvoiceService,
		private smartContractService: SmartContractService,
		private noteService: NoteService,
		private tabService: TabService
	) {
	}

	ngOnInit() {
		this.columnsConfig = this.configService.getTableFields(this.invoiceService.dataObj, false);
		this.exportAction.push(this.configService.getExportAction());
		this.actions = this.configService.getActions(this.dataObj);
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}

		this.pendingActions = this.configService.getActions('pendinginvoice');
		if (this.pendingActions.length === 0) {
			this.pendingActions.push(this.configService.getExportAction());
		}

		this.archivedActions = this.configService.getActions('archivedinvoice');
		if (this.archivedActions.length === 0) {
			this.archivedActions.push(this.configService.getExportAction());
		}

		this.invoiceService.dataConfig = this.configService.getDataObj(this.dataObj);
		this.displayService.clearLoading();
		this.helpService.invoices.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		this.route.params.subscribe(params => {
			this.initTab = params['initTab'];
			this.tabService.loadTab(this.invoiceService.tabsData.listTabs, this.invoiceService, this.initTab);
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			console.log('USER SETTINGS LISTENER');
			this.tabService.loadTab(this.invoiceService.tabsData.listTabs, this.invoiceService, this.initTab);
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	getActionsForTab() {
		const thisTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.listTabs).prop;
		if (thisTab === 'all') {
			return this.exportAction;
		} else if (thisTab === 'pending') {
			return this.pendingActions;
		} else if (thisTab === 'failed') {
			return this.actions;
		} else if (thisTab === 'inactive') {
			return this.archivedActions;
		}
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		if (event.action.prop === 'forcereconciliation') {
			this.modalForm.showModal(event.action, this.configService.invoiceSCDataObj, this.dataService.selectedTableRows);
		} else if (event.action.prop === 'invoicearchive') {
			this.archiveInvoices(event.action.prop);
		} else if (event.action.prop === 'invoicerestore') {
			this.restoreInvoices(event.action.prop);
		} else {
			this.showExportModal = true;
		}
	}

	archiveInvoices(prop) {
		const ids = [];
		this.dataService.selectedTableRows.forEach((row) => {
			ids.push(row['_id']);
		});

		const data = {
			ids: ids
		};
		this.smartContractService.submitSmartContract(data, prop, this);
	}

	restoreInvoices(prop) {
		const ids = [];
		this.dataService.selectedTableRows.forEach((row) => {
			ids.push(row['_id']);
		});

		const data = {
			ids: ids
		};
		this.smartContractService.submitSmartContract(data, prop, this);
	}

	successCall() {
		this.dataService.clearSelectedTableRows();
		this.invoiceService.loadInvoicesForTab(this.invoiceService.getActiveTab(this.invoiceService.tabsData.listTabs));
	}

	errorCall(err) {
		this.noteService.displayError('Failed to process the selected invoices');
		this.invoiceService.loadInvoicesForTab(this.invoiceService.getActiveTab(this.invoiceService.tabsData.listTabs));
		console.log('BULK INVOICES ERROR');
	}

	partialCall(res) {
		this.invoiceService.loadInvoicesForTab(this.invoiceService.getActiveTab(this.invoiceService.tabsData.listTabs));
	}

	invoiceTableClick(event) {
		this.invoiceService.tableClick(event);
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.columnsConfig, this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}
}
